import React from 'react';
import api from 'rawr/api';
import AsyncData2 from 'rawr/mixins/AsyncData2';
import Loading from 'rawr/controls/LoadingSpinner';
import btn from 'rawr/layout/btn';
import cn from 'classnames';
import _ from 'lodash';

export default React.createClass({
	mixins: [AsyncData2],
    propTypes: {
        subjectType: React.PropTypes.oneOf(['insight', 'qb']),
    },
    data: {
        subjects: {
            params: () => null,
            promise: () => api('/n/apinsight/api/subjects'),
        }
    },
    getDefaultProps() {
        return {
            urlPrefix: '/n/apinsight#/',
        };
    },
	render() {
        const {subjects=[], subjectsLoading} = this.state;
        const {urlPrefix, subjectType} = this.props;

        if (subjectsLoading) {
            return <Loading />;
        }

        if (subjects.length < 1) {
            return null;
        }

        // TODO: proper subject checking. See CB-433
        // QB >= 100, AP-I < 100
        var subjectList = subjects;
        if (subjectType === "insight") {
            subjectList = _.filter(subjects, s => s.id < 100 );
        }
        if (subjectType === "qb") {
           subjectList = _.filter(subjects, s => s.id >= 100 );
        }
        subjectList = _.sortBy( subjectList, 'name');

        return (
            <div {...this.props}>
                {subjectList.map(s => <div className="launchpoint" key={s.id}>
                    <div className="launchpoint__title">
                        <h3 className="title__heading">{s.name}</h3>
                    </div>
                    <div className="launchpoint__action">
                        <a className={cn('launch_btn', btn({color: 'light_blue'}))} href={`${urlPrefix}${s.id}?p=1`} >Launch</a>
                    </div>
                </div>)}
            </div>
        );
	}
});



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/apinsight/controls/SubjectList.jsx
 **/